export default {
  docsUrl: "https://docs.bizflycloud.vn",
  docsBetaUrl: "https://docs-beta.bizflycloud.vn",
  account: {
    securityManage:
      "https://beta.manage.bizflycloud.vn/account/configuration/ssh",
    securityStaging:
      "https://beta-staging.bizflycloud.vn/account/configuration/ssh",
  },
  networkVpc: {
    create:
      "https://hn.manage.bizflycloud.vn/virtual-private-cloud/networks/create",
  },
  iaasCloud: {
    snapshot: {
      create: "/iaas-cloud/snapshots/create",
    },
    volume: {
      create: "/iaas-cloud/volumes/create",
    },
    customImage: {
      create: "/iaas-cloud/custom-images/create",
    },
    server: {
      create: "/iaas-cloud/servers/create",
    },
  },
  dnsIntegration: "https://docs.bizflycloud.vn/cdn/howtos/dns_integration/",
  configSSL: "https://docs.bizflycloud.vn/load_balancer/howtos/config_ssl",
  sslEncrypt:
    "https://bizflycloud.vn/tin-tuc/hang-loat-thiet-bi-va-website-gap-su-co-truy-cap-do-loi-ssl-lets-encrypt-nguyen-nhan-va-cach-khac-phuc-20211022105335717.htm",
};
